import Vue from 'vue'
import {
  Button,
  Layout,
  Row,
  Col,
  Avatar,
  Form,
  Input,
  InputNumber,
  FormModel,
  Tabs,
  Menu,
  Icon,
  List,
  Collapse,
  Tag,
  Pagination,
  Select,
  Upload,
  Alert,
  Table,
  Popconfirm,
  Popover,
  Tree,
  Tooltip,
  Carousel,
  message
} from 'ant-design-vue'
Vue.use(Button)
Vue.use(Tabs)
Vue.use(Row)
Vue.use(Button)
Vue.use(Layout)
Vue.use(Avatar)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Col)
Vue.use(Tabs)
Vue.use(Menu)
Vue.use(Icon)
Vue.use(List)
Vue.use(Collapse)
Vue.use(Tag)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Upload)
Vue.use(Table)
Vue.use(Alert)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Tree)
Vue.use(Tooltip)
Vue.use(Carousel)

// Vue.comjonent(Button.name, Button)
// Vue.component(Tabs.name, Tabs)
// Vue.component(Row.name, Row)
// Vue.component(Button.name, Button)
// Vue.component(Layout.name, Layout)
// Vue.component(Avatar.name, Avatar)
// Vue.component(Form.name, Form)
// Vue.component(FormModel.name, FormModel)
// Vue.component(Input.name, Input)
// Vue.component(Col.name, Col)
// Vue.component(Tabs.name, Tabs)
// Vue.component(Menu.name, Menu)
// Vue.component(Icon.name, Icon)
// Vue.component(List.name, List)
// Vue.component(Collapse.name, Collapse)
// Vue.component(Tag.name, Tag)

Vue.prototype.$message = message
